<!------------ START TEMPLATE ------------>
<template>
  <div id="data-list-list-view" class="data-list-container">
    <add-new-data-sidebar
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="addNewDataSidebar = false"
      :form="formSideBar"
      :title="titleSideBar"
      :dados="dadosSideBar"
      @concluido="concluido"
    />

    <vs-table
      noDataText="Nenhum Tipo de Pagamento Encontrado"
      class="tablePrincipal"
      ref="table"
      multiple
      v-model="selected"
      pagination
      :max-items="itemsPerPage"
      search
      :data="itens"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div class="flex flex-wrap-reverse items-center">
          <!------------ START  MENU DE AÇÕES ------------>
          <vs-dropdown
            vs-trigger-click
            class="cursor-pointer mr-4 mb-4"
            data-testId="actions_dropdown"
          >
            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32"
            >
              <span class="mr-2">Ações</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item
                @click="inativar"
                data-testId="action_inativar"
                v-if="$can($actionsDefault.Inativar, subjectPermission)"
              >
                <span>Inativar</span>
              </vs-dropdown-item>
              <vs-dropdown-item
                @click="reativar"
                data-testId="action_reativar"
                v-if="$can($actionsDefault.Inativar, subjectPermission)"
              >
                <span>Reativar</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="imprimir" data-testId="action_imprimir">
                <span>Imprimir</span>
              </vs-dropdown-item>
              <vs-dropdown-item
                data-testId="action_exportar"
                v-if="$can($actionsDefault.Exportar, subjectPermission)"
              >
                <span>
                  <downloadexcel
                    :data="selected"
                    :fields="colunas"
                    name="TipoPagamento.xls"
                    type="xls"
                    >Exportar</downloadexcel
                  >
                </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
          <!------------ END MENU DE AÇÕES ------------>

          <!------------ START ADD NOVO Tipo Pagamento ------------>
          <div
            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
            data-testId="add_tipo_pagamento"
            @click="openSideBar({})"
            v-if="$can($actionsDefault.Escrita, subjectPermission)"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary"
              >Adicionar novo Tipo de Pagamento</span
            >
          </div>
        </div>
        <!------------ END ADD NOVO Tipo Pagamento ------------>

        <!------------ START ITENS POR PÁGINA ------------>
        <vs-dropdown
          vs-trigger-click
          class="cursor-pointer mb-4 mr-4"
          data-testId="items_per_page_dropdown"
        >
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                itens.length - currentPage * itemsPerPage > 0
                  ? currentPage * itemsPerPage
                  : itens.length
              }}
              de {{ itens.length }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item
              @click="itemsPerPage = 5"
              data-testId="items_per_page_5"
            >
              <span>5</span>
            </vs-dropdown-item>
            <vs-dropdown-item
              @click="itemsPerPage = 10"
              data-testId="items_per_page_10"
            >
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item
              @click="itemsPerPage = 25"
              data-testId="items_per_page_25"
            >
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item
              @click="itemsPerPage = 50"
              data-testId="items_per_page_50"
            >
              <span>50</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <!------------ END ITENS POR PÁGINA ------------>

      <!------------ START TITULO DA TABELA ------------>

      <template slot="thead">
        <vs-th sort-key="Nome">Nome</vs-th>
        <vs-th sort-key="Nome">Qtd de Parcelas</vs-th>
        <vs-th sort-key="Status">Status</vs-th>
        <vs-th>Ações</vs-th>
      </template>
      <!------------ END TITULO DA TABELA ------------>

      <!------------ START TABELA ------------>
      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-category">{{ tr.TipoPagamento }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.qtdParcelas }}</p>
            </vs-td>
            <vs-td>
              <vs-chip
                :color="getStatusColor(tr.deletedAt)"
                class="product-order-status"
                >{{ getStatusString(tr.deletedAt) }}</vs-chip
              >
            </vs-td>
            <vs-td>
              <p class="product-price">
                <vs-button
                  radius
                  color="dark"
                  v-tooltip="'Detalhes'"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-search"
                  class="d-inline"
                  :data-testId="'detalhes_' + tr.idTipoPagamento"
                  @click="opemModal(tr.idTipoPagamento)"
                ></vs-button>
                <vs-button
                  radius
                  color="success"
                  v-tooltip="'Editar'"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-edit"
                  class="d-inline"
                  :data-testId="'editar_' + tr.idTipoPagamento"
                  @click="openSideBar(tr)"
                  v-if="$can($actionsDefault.Escrita, subjectPermission)"
                ></vs-button>
                <vs-button
                  radius
                  color="primary"
                  :data-testId="'acquirers_config_' + tr.idTipoPagamento"
                  v-tooltip="'Configurar adquirentes'"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-credit-card"
                  class="d-inline"
                  @click="openAcquirerModal(tr)"
                  v-if="
                    tr.idTipoPagamento === PAYMENT_METHODS.CREDIT_CARD.id &&
                    $can($actionsDefault.Escrita, subjectPermission)
                  "
                ></vs-button>
                <vs-button
                  radius
                  color="primary"
                  :data-testId="'acquirers_history_' + tr.idTipoPagamento"
                  v-tooltip="'Histórico de alterações das adquirentes'"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-list"
                  class="d-inline"
                  @click="openAcquirerHistoryModal(tr)"
                  v-if="
                    tr.idTipoPagamento === PAYMENT_METHODS.CREDIT_CARD.id &&
                    $can($actionsDefault.Leitura, subjectPermission)
                  "
                ></vs-button>
              </p>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <!------------ END TABELA ------------>

    <!------------ START INFORMAÇÕES DO Setor ------------>
    <ModalInfo
      :modalSelecionado="modalSelecionado"
      :popupActive="popupActive"
      :title="`Dados da ${entidade}`"
      @close="popupActive = false"
    ></ModalInfo>

    <!------------ END INFORMAÇÕES DO Setor ------------>

    <AcquirerConfigModal
      :active="acquirerModalActive"
      :payment-type-id="
        creditCardModalRow ? creditCardModalRow.idTipoPagamento : null
      "
      @save="saveAcquirerConfig"
      @close="acquirerModalActive = false"
    />

    <AcquirerHistoryModal
      :active="acquirerHistoryModalActive"
      :payment-type-id="
        creditCardModalRow ? creditCardModalRow.idTipoPagamento : null
      "
      @close="acquirerHistoryModalActive = false"
    />
  </div>
</template>
<!------------ START TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import AddNewDataSidebar from './../Includes/SideBar';
import service from '../../services';
import downloadexcel from 'vue-json-excel';
import ModalInfo from '../../components/ModalInfo';
import AcquirerConfigModal from '../modais/AcquirerConfigModal.vue';
import AcquirerHistoryModal from '../modais/AcquirerHistoryModal.vue';
import creditCardAcquirerApi from '../../services/credit.card.acquirer.api';
import { PAYMENT_METHODS } from '../../utils/constants';
import notify from '../../utils/notify';

export default {
  components: {
    AddNewDataSidebar,
    downloadexcel,
    ModalInfo,
    AcquirerConfigModal,
    AcquirerHistoryModal,
  },
  props: ['subjectPermission'],
  data() {
    return {
      idEmpresa: null,
      dadosSideBar: {},
      controllerGeral: 'TipoPagamento',
      formSideBar: 'TipoPagamento',
      entidade: 'TipoPagamento',
      titleSideBar: 'Adicionar Tipo de Pagamento',
      popupActive: false,
      modalSelecionado: [],
      selected: [],
      itens: [],
      colunas: {},
      itemsPerPage: 10,
      isMounted: false,
      addNewDataSidebar: false,
      PAYMENT_METHODS,
      acquirerModalActive: false,
      acquirerHistoryModalActive: false,
      creditCardModalRow: null,
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
  },
  methods: {
    imprimir() {
      setTimeout(function () {
        window.print();
      }, 500);
    },
    inativar() {
      if (this.selected.length > 0) {
        this.$vs.loading();
        var ids = [];
        this.selected.forEach((element) => {
          ids.push(element.idTipoPagamento);
        });
        service
          .post(this.controllerGeral, 'Inativar', { ids: ids })
          .then((res) => {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Registro inativado(s) com sucesso',
              color: 'success',
            });
            this.$vs.loading.close();
            this.buscaDados();
          })
          .catch((e) => {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: e,
              color: 'danger',
            });
            this.$vs.loading.close();
          });
      } else {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Selecione pelo menos um registro',
          color: 'danger',
        });
      }
    },
    reativar() {
      if (this.selected.length > 0) {
        this.$vs.loading();
        var ids = [];
        this.selected.forEach((element) => {
          ids.push(element.idTipoPagamento);
        });
        service
          .post(this.controllerGeral, 'Reativar', { ids: ids })
          .then((res) => {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Registro reativado(s) com sucesso',
              color: 'success',
            });
            this.$vs.loading.close();
            this.buscaDados();
          })
          .catch((e) => {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: e,
              color: 'danger',
            });
            this.$vs.loading.close();
          });
      } else {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Selecione pelo menos um registro',
          color: 'danger',
        });
      }
    },
    buscaDados() {
      this.selected = [];
      this.$vs.loading();
      service
        .getAll(this.controllerGeral, {}, 'list/idEmpresa=' + this.idEmpresa)
        .then((res) => {
          this.itens = [];
          res.data.forEach((element) => {
            element.Empresa = element.TipoPagamento_Empresa.nome;
            element.TipoPagamento =
              element.TipoPagamento_domTipoPagamento.nomePagamento;
            delete element.TipoPagamento_Empresa;
            delete element.TipoPagamento_domTipoPagamento;
            this.itens.push(element);
          });

          if (this.itens.length > 0) {
            this.colunas = {};
            Object.keys(this.itens[0]).forEach((element) => {
              if (
                element != 'createdAt' &&
                element != 'updatedAt' &&
                element != 'deletedAt' &&
                element.indexOf('id') != 0
              ) {
                this.colunas[element] = element;
              }
            });
          }

          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    openSideBar(dados) {
      dados.idTipoPagamento == null
        ? (this.titleSideBar = `Adicionar Tipo de Pagamento `)
        : (this.titleSideBar = `Editar Tipo de Pagamento`);
      this.dadosSideBar = dados;
      this.addNewDataSidebar = true;
    },
    opemModal(cod) {
      this.modalSelecionado = [];
      this.popupActive = true;
      var item = this.itens.find((x) => x.idTipoPagamento == cod);
      Object.keys(item).forEach((element) => {
        if (
          element != 'createdAt' &&
          element != 'updatedAt' &&
          element != 'deletedAt' &&
          element.indexOf('id') != 0
        )
          this.modalSelecionado.push({
            coluna: element,
            [element]: item[element],
          });
      });
    },
    openAcquirerModal(tr) {
      this.creditCardModalRow = tr;
      this.acquirerModalActive = true;
    },
    openAcquirerHistoryModal(tr) {
      this.creditCardModalRow = tr;
      this.acquirerHistoryModalActive = true;
    },
    saveAcquirerConfig(acquirers) {
      this.$vs.loading();
      creditCardAcquirerApi
        .updateAcquirers(this.creditCardModalRow.idTipoPagamento, acquirers)
        .then(() => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Configuração de adquirente salva com sucesso',
            color: 'success',
          });
          this.acquirerModalActive = false;
          this.$vs.loading.close();
          this.buscaDados();
        })
        .catch((error) => {
          notify.notifyFail(this.$vs, error);
          this.$vs.loading.close();
        });
    },
    concluido() {
      this.buscaDados();
    },
    getStatusColor(data) {
      if (data == null) return 'success';
      return 'danger';
    },
    getStatusString(data) {
      if (data == null) return 'Ativo';
      return 'Inativo';
    },
  },
  created() {
    this.buscaDados();
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>
<!------------ END SCRIPT ------------>

<!------------ START STYLE ------------>
<style lang="scss">
@media print {
  #content-area {
    margin-left: 0px;
  }
  .navbar-sticky .router-view .router-content {
    margin-top: 0px;
  }
  .vs-content-sidebar,
  .con-pagination-table,
  #data-list-list-view .vs-con-table .vs-table--header,
  .the-footer,
  .vs-navbar {
    display: none !important;
  }
  body,
  .vs-con-table .vs-con-tbody {
    background-color: #ffffff;
  }
  .vx-card,
  #data-list-list-view .vs-con-table .vs-table tr {
    box-shadow: none !important;
  }
  .td-check {
    visibility: hidden;
  }
}

#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>

<!------------ END STYLE ------------>
